import React from 'react';
import App from '../../App';
import AuthService from '../../services/AuthService';

const LocalAdminApp = () => <App auth={AuthService.cookieAuth} />;

export default LocalAdminApp;
